import type { FC, ReactNode } from 'react'
import type { History } from 'history'

export {
  Await,
  Link,
  NavLink,
  Navigate,
  NavigationType,
  Outlet,
  Route,
  Routes,
  MemoryRouter,
  createPath,
  createRoutesFromChildren,
  createRoutesFromElements,
  createSearchParams,
  generatePath,
  isRouteErrorResponse,
  matchPath,
  matchRoutes,
  parsePath,
  renderMatches,
  resolvePath,
  useBlocker,
  useAsyncError,
  useAsyncValue,
  useBeforeUnload,
  useHref,
  useInRouterContext,
  useLinkClickHandler,
  useLoaderData,
  useLocation,
  useMatch,
  useMatches,
  useNavigate,
  useOutlet,
  useOutletContext,
  useParams,
  useResolvedPath,
  useRouteError,
  useRoutes,
  useSearchParams,
} from 'react-router-dom-v5-compat'

export const TestRouter: FC<{ history: History, children?: ReactNode }> = () => {
  throw new Error('TestRouter is only for unit test, not available in browser')
}
